import { render, staticRenderFns } from "./admin_folder.vue?vue&type=template&id=5e14b9c0"
import script from "./admin_folder.vue?vue&type=script&lang=js"
export * from "./admin_folder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports